import type { Scalars } from '@bb/automaton';

const ASSUME_ORG_TYPE: Scalars['String'][] = ['answering', 'mlsStaff'];

const isAssumeOrgType = (type: Scalars['String']) =>
  ASSUME_ORG_TYPE.includes(type);

export default isAssumeOrgType;
